import styles from './Layout.module.css'

const tones = new Set(['neutral', 'info', 'success', 'warning', 'danger'])

function resolveTone(tone) {
  return tones.has(tone) ? tone : 'neutral'
}

/**
 * A dense, page-wide status strip: facts on the left, one live message in the
 * middle, optional controls on the right. Sticks to the bottom of the scrolling
 * page by default so it reads like an editor status bar rather than a card.
 * `size="regular"` gives the bar full control height so it can carry a
 * workspace's primary actions (save, publish) instead of a separate dock.
 */
export function StatusBar({
  items = [],
  message,
  start,
  end,
  label = 'Status',
  sticky = true,
  size = 'compact',
  className = '',
}) {
  return (
    <section
      className={[styles.statusBar, size === 'regular' ? styles.statusBarRegular : '', sticky ? styles.statusBarSticky : '', className].filter(Boolean).join(' ')}
      aria-label={label}
      data-sticky={sticky ? 'true' : 'false'}
      data-size={size === 'regular' ? 'regular' : 'compact'}
    >
      {start ? <div className={styles.statusBarStart}>{start}</div> : null}
      {items.length ? (
        <ul className={styles.statusBarItems}>
          {items.map((item) => (
            <li
              key={item.key || item.label}
              className={styles.statusBarItem}
              data-tone={resolveTone(item.tone)}
              title={item.title}
              aria-label={item.description || `${item.label}: ${item.value}`}
            >
              {item.icon ? <span className={styles.statusBarIcon} aria-hidden="true">{item.icon}</span> : null}
              <span className={styles.statusBarLabel}>{item.label}</span>
              <span className={styles.statusBarValue}>{item.value}</span>
            </li>
          ))}
        </ul>
      ) : null}
      <p className={styles.statusBarMessage} data-tone={resolveTone(message?.tone)} role="status" aria-live="polite">
        {message?.text || ''}
      </p>
      {end ? <div className={styles.statusBarEnd}>{end}</div> : null}
    </section>
  )
}

export default StatusBar
